<template>
  <ul id="list-tasks">
    <li>

      <div id='oblea' v-show="it.tipoOblea == 1">
        <div id='s1'>
          <img :src="imagenProducto" style="height: 52px" /> 
        </div> 

        <div id='s2' :title="item.producto">
          <span id='titulo'>{{item.producto}}</span>
        </div> 

        <div id='s22'>
          <div>
            <span class='label'>Precio:</span> 
            <span class='value'>${{item.precio | formatMoney}}</span>
          </div>
          <div>
            <span class='label'>Subtotal:</span>
            <span class='value'>${{it.cantidad*item.precio | formatMoney}}</span>
          </div>
        </div> 

        <div id='s3'>
          <div id='cc'>
            <span id='label-cantidad'>Cantidad</span> 
            <input class='cantidad' :class="{cantidadInv: cantInvalida}" type="text" v-model="it.cantidad" v-on:keyup="updateCantidad">
          </div> 
        </div> 
        <div id='s4'>
          <img id='btnEliminarItem'  @click="btnEliminarItem"  src="/dist/icon-delete.png"  style= "width:20px;height:20px">   
        </div> 
      </div>


      <div id='oblea-desc' v-show="it.tipoOblea == 2" >
          <div id='s1'>
          </div> 
  
          <div id='s2'>
            <span id='titulo'>{{item.producto}}</span>
          </div> 
  
          <div id='s222'>
              <span class='label-desc'>Descuento:</span> 
              <span class='value'> ${{item.precio | formatMoney}}</span>
          </div> 
  
          <div id='s3'>
          </div> 
          <div id='s4'>
          </div> 
        </div>
  
    </li>
  </ul>
</template>


<script>
  import axios from 'axios'

  export default {
    name: 'item-pedido',
    props: ['item'],
    data()  {
       return {
        cantInvalida: false,
         it: this.item ,
         valor:'',
         imagenProducto: null  
       }
    },

    watch: {
      item: {
        immediate: true,
        handler  () {
          this.getImage()
        }
      }
    },

    methods: {

      btnEliminarItem: function () {
        this.$emit('eliminarItem', this.item.id);
       },
       
      updateCantidad: function() {
        var rex = new RegExp(/^\d+$/);
        if (rex.test(this.it.cantidad))  
        {
          if (this.it.cantidad > 0)
          {
            this.cantInvalida = false
          }
          else
          {
            this.cantInvalida = true
          }
        }
        else
        {
          this.cantInvalida = true
        }

        var itemUpdate = {
                          'archivoId': this.item.archivoId,
                          'cantidad': parseInt(this.it.cantidad),
                          'descripcion': this.item.descripcion,
                          'id': this.item.id,
                          'idCategoria': this.item.idCategoria,
                          'idSubcategoria': this.item.idSubcategoria,
                          'peso': this.item.peso,
                          'precio': this.item.precio,
                          'producto': this.item.producto,
                          'promocionId': this.item.promocionId, 
                          'tipoOblea': this.item.tipoOblea,
                         }

        this.$store.commit('pedido/updateItemCarrito',itemUpdate)
      },


      getImage () {
        if (this.item.archivoId != null)
        {
          var img = this.$store.state.pedido.imagenes.find( e => e.id === this.item.archivoId);
          if (img != null)
          {
            this.imagenProducto = img.image
          } 
          else
          {
            let config = {
              method: 'GET',
              responseType: 'blob',
              url:'/WebSalesArchivo?ArchivoId='+this.item.archivoId+'&Ancho=150',
              headers: {
                Token:this.$store.state.user.token,
                ClientSecret: process.env.CLIENT_SECRET,
                EmpresaId: process.env.EMPRESA_ID
              }
            }
            axios
            .request(config)
            .then(response => {
              let reader = new FileReader()
              reader.onload = () => {
                this.imagenProducto = reader.result
                var img = {id:this.item.archivoId,image:this.imagenProducto} 
                this.$store.commit('pedido/saveImage',img)   
              }
              console.log(response.data)
              reader.readAsDataURL(response.data)
            })
            .catch(err => console.log(err))
          }
        }
      }
    }


  }
</script>


<style scoped>

* {
  margin:  0;
  padding: 0;
}


#oblea {
  width: 630px;
  height:55px;
  margin-bottom: 5px;
  background-color: #ffffff;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}

#oblea-desc {
  width: 630px;
  height:30px;
  margin-bottom: 5px;
  background-color: #ffffaa;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}



#s1{
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}

#s222{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center; 
}

#s3{
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s4{
  width: 6%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}


.label-desc{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 70px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#label-subtotal{
  font-size: 12px;
  color: #656E76;
  margin-left: 10%;
}


#label-cantidad {
 font-size: 12px;
 color: #656E76;
 font-weight: 500;
 }


.cantidad {
  width: 40px;
  height: 22px;
  margin-left: 5px;
  border-radius: 4px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  text-align: center;
  color: #656E76;
  outline: none;
  }


.cantidadInv {
  width: 40px;
  height: 22px;
  margin-left: 5px;
  border-radius: 4px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #ff0000;
  text-align: center;
  color: #656E76;
  outline: none;
  }



#btnEliminarItem:hover{
  cursor: pointer;  
}


 </style>


// WEBPACK FOOTER //
// src/components/views/pedido/ItemPedido.vue